export default "__VITE_ASSET__DDFfLuAs__"